// extracted by mini-css-extract-plugin
export default {"picker":"legend_picker__JGwpQ","item":"legend_item__2q2Dn"};